"use client";

import React, { useEffect, useState } from "react";
import ProductCardV2 from "../product/ProductCardV2";

import QuickViewModal from "../productdetail/QuickViewModal";
import { Product } from "@/packages/types/products";
import { ProductGridSkeleton } from "../common/Skeletons";

interface Props {
  products: Product[] | undefined;
}

// const PRODUCTS_PER_PAGE = 16;

const ProductGrid: React.FC<Props> = ({ products }) => {
  const [currentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 400);
    return () => clearTimeout(timeout);
  }, [currentPage, products]);

  const handleQuickView = (product: Product) => {
    setSelectedProduct(product);
    setIsQuickViewOpen(true);
  };

  return (
    <div>
      {loading || !products ? (
        <ProductGridSkeleton count={10} />
      ) : (
        <div className="grid gap-x-2 md:gap-x-5 gap-y-4 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 mt-5 mb-5">
          {products?.map((product) => (
            <ProductCardV2
              className="cursor-pointer rounded-[8px]"
              key={product.id}
              product={product}
              onQuickView={() => handleQuickView(product)}
            />
          ))}

          {/* <div className="col-span-full">
            <Banner
              banners={LABELS.BANNER}
              className="h-[200px] md:h-[445px]"
            />
          </div> */}

          {/* {nextNine?.map((product) => (
            <ProductCard
              className="cursor-pointer rounded-[8px]"
              key={product.id}
              product={product}
              onQuickView={() => handleQuickView(product)}
            />
          ))} */}
        </div>
      )}

      {/* <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      /> */}

      {/*  Quick View Modal */}
      <QuickViewModal
        isOpen={isQuickViewOpen}
        onClose={() => setIsQuickViewOpen(false)}
        slug={selectedProduct?.slug}
      />
    </div>
  );
};

export default ProductGrid;
